import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-notice',
  standalone: false,
  templateUrl: './notice.component.html',
  styleUrl: './notice.component.scss'
})
export class NoticeComponent {
  constructor(
    private dialogRef: MatDialogRef<NoticeComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }


  ok() {
    this.dialogRef.close('ok');
  }
  cancel() {
    this.dialogRef.close('cancel');
  }
}
